import { http } from "./http"

export const startAssesment = async (id: string) => {
    return (await http.post(`/assessments/start/${id}`)).data
}

export const continueAssessment = async (id: string) => {
    return (await http.post(`/assessments/continue/${id}`)).data
}